/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';
import _ from 'lodash';
import crypto from 'crypto-js';

/*---------------------------------------------------------*\
 * userauthService
 \*---------------------------------------------------------*/


function authService(laboxSSapi,storage) {

  var currenttimestamp = new Date().getTime();
  var loginPayload = {};
  var secretAndKey = getConfig();
  console.log('Secret and Key -->', secretAndKey);
  console.log('Secret and Key -->', storage.getItem('session', 'env'));

  function generateMessage(primaryId,secretID){
    return "/login/trustedLogin?id="+ primaryId +"&requestTime="+currenttimestamp+"&secretKeyId="+secretID;
  }

  function setPrimaryId(){
    return laboxSSapi.getAllOptimumIds().then((res) => {
      if(res && res.data.optimumIdInfo !== null && res.data.status === 'Success'){
        console.log('get all optimum id response --> ',res);
        var primaryidObj = _.find(res.data.optimumIdInfo, function(o) { return o.userIDType == "true"; });
        storage.setItem('session','optimum_ids',res.data.optimumIdInfo);
        storage.setItem('session','primary_id',primaryidObj.loginID);
        return true;
        console.log('primary id is set up in session storage');
      }
      else{
        console.log('primary id  not set up in session storage and res.data is--> ',res.data);
        return null;
      }
    },(reserr)=>{
        return null;
    });
  }

  function generateHMAC (primaryid){
    var validMsg = generateMessage(primaryid,secretAndKey.bpKeySecretID);
    return crypto.HmacSHA256(validMsg,secretAndKey.bpKeySecret).toString();
  }

  function setPayload(payload){
    loginPayload = payload;
    console.log('id hmac timestamp and secret id : '+ loginPayload);
  }

  function getPayload(){
    return loginPayload;
  }

  function generateLoginPayload(){
    return setPrimaryId().then((res) => {
      if(!res){
        console.log('primary id not set up and res is null');
        setPayload(null);
      }
      else{
          console.log('this is primary id setting response-->',res);
          var primaryID = storage.getItem('session','primary_id');
          console.log('Got primary ID for generate payload',primaryID);
          var generatedHmac = generateHMAC(primaryID);
          var logindata = {
            "id":primaryID,
            "secretKeyId": secretAndKey.bpKeySecretID,
            "requestTime": currenttimestamp,
            "hmac": generatedHmac
          };
          setPayload(JSON.stringify(logindata));
      }
    },(reserr)=>{
        setPayload(null);
    });
  }

  this.trustedLogin = () => {
    return generateLoginPayload().then(()=>{
      console.log('Start Login with payload --> ',getPayload());
      if(getPayload() && getPayload()!= null){
        var data = {"payload":getPayload()};
        console.log('generateLoginPayload is success. payload is not null and it is---> ',getPayload());
        //return laboxSSapi.wrap(laboxSSapi.config.dev.cassservice+"login/trustedLogin", {},'trustedLogin','POST',getPayload());
        return laboxSSapi.wrap("/api/bpglobal/login", {},'trustedLogin','POST',data);
      }
      else{
        console.log('generateLoginPayload is success. payload is null and it is---> ',getPayload());
        return null;
      }
    },()=>{
      return null;
    });
  };

  function getConfig() {
    if (storage.getItem('session', 'env') === 'prod') {
      return laboxSSapi.config.prod;
    } else if (storage.getItem('session', 'env') === 'stage') {
      return laboxSSapi.config.stage;
    } else {
      return laboxSSapi.config.dev;
    }
  }
}

authService.$inject = [
  'laboxSSapi',
  'storage'
];

const api = angular.module('userauthService', ['labox.sse.api','storage'])
                   .service('authService', authService);

export default api;



// WEBPACK FOOTER //
// ./client/app/services/userauth.js